import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { Image } from '@sg/garnish';

import { VerifiedByIdMeImage } from '../../assets';

// ─────────────────────────────────────────────────────────────────────────────

export const IdMeVerifiedBadge = () => {
  const { formatMessage } = useIntl();

  return (
    <Image
      source={VerifiedByIdMeImage}
      alt={formatMessage(messages.verifiedByIdMe)}
      contentFit="contain"
      style={styles.image}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  verifiedByIdMe: {
    defaultMessage: 'Verified by ID.me',
    description: 'ID.me | Verified badge alt text',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const BADGE_WIDTH = 198;

const ARTWORK_WIDTH = 760;
const ARTWORK_HEIGHT = 92;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    width: BADGE_WIDTH,
    aspectRatio: ARTWORK_WIDTH / ARTWORK_HEIGHT,
  },
});
